import {Text, Toggle} from '@/components-v2/atoms'
import {RewardItem} from './Rewards'
import {useBuyMultipleProductsCondition} from '@/containers/Promotions/components/PromotionsConditions/useBuyMultipleProductsCondition'
import PromotionSelectionModalV2 from '@/features/Promotions/components/PromotionSelectionModalV2'
import {Fragment} from 'react'
import {AmountInput, ProductsDropdown, QuantityDropdown} from './ConditionFields'

const rowClassName = 'flex flex-wrap items-center gap-4'

/**
 * v2 "Buy <x> <products> and buy <y> <products> and get <reward>" rows for BUY_MULTIPLE promotions.
 * State and handlers live in useBuyMultipleProductsCondition, shared with the legacy view.
 */
export const BuyMultipleProductsCondition = ({promotionCondition, index, selectedPromotionCondition = 'UN'}) => {
  const {
    isLoadingConfig,
    isAmountTab,
    currencyCode,
    isIndividualRewardsFeatureEnabled,
    hasIndividualRewards,
    rows,
    modalProps,
    modalConditionValues,
    handleBuyCount,
    handleBuyAmount,
    handleSelectedBuyItem,
    handleToggleIndividualRewards,
    handleSubmitModal,
    handleCloseModal,
  } = useBuyMultipleProductsCondition({promotionCondition, selectedPromotionCondition})

  if (!promotionCondition) {
    return null
  }

  const renderBuyFields = row => (
    <>
      <Text>{row.label}</Text>
      {isAmountTab ? (
        <AmountInput
          currencyCode={currencyCode}
          value={row.buyCount?.toString() || ''}
          onChange={value => handleBuyAmount(value, row.condIndex)}
          hasError={row.isError}
        />
      ) : (
        <QuantityDropdown
          options={row.qtyOptions}
          value={row.quantityValue}
          onChange={values => handleBuyCount(values, row.condIndex)}
          isLoading={isLoadingConfig}
          hasError={row.isError}
        />
      )}
      <ProductsDropdown
        options={row.typeOptions}
        value={row.productsValue}
        selectedText={row.selectedValuesText}
        onChange={values => handleSelectedBuyItem(values, row.condIndex)}
        isLoading={isLoadingConfig}
        disabled={index > 0}
      />
    </>
  )

  const renderReward = (rewardIndex = 0, showDeleteLayer = true) => (
    <>
      <Text>and get</Text>
      <RewardItem
        promotionCondition={promotionCondition}
        index={index}
        rewardIndex={rewardIndex}
        showDeleteLayer={showDeleteLayer}
      />
    </>
  )

  return (
    <div className="flex flex-col gap-4">
      {index === 0 && isIndividualRewardsFeatureEnabled && (
        <Toggle
          checked={hasIndividualRewards}
          onUpdate={handleToggleIndividualRewards}
          size="small"
          label="Enable Individual Rewards"
        />
      )}
      {hasIndividualRewards ? (
        // One row per buy condition, each with its own reward; the layer's delete button sits on the last row
        rows.map(row => (
          <div key={row.condIndex} className={rowClassName}>
            {renderBuyFields(row)}
            {renderReward(row.condIndex, row.condIndex === rows.length - 1)}
          </div>
        ))
      ) : (
        <div className={rowClassName}>
          {rows.map(row => (
            <Fragment key={row.condIndex}>{renderBuyFields(row)}</Fragment>
          ))}
          {renderReward()}
        </div>
      )}
      <PromotionSelectionModalV2
        key={JSON.stringify(modalProps)}
        show={modalProps.show}
        type={modalProps.type}
        onClose={handleCloseModal}
        onSubmit={handleSubmitModal}
        conditionValues={modalConditionValues}
      />
    </div>
  )
}
